(() => {
  const body = document.body;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!body || body.classList.contains('shopify-design-mode') || reducedMotion.matches) return;

  const sections = new Set();
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('michele-entry-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  const observeSections = () => {
    document.querySelectorAll('.shopify-section').forEach((section, index) => {
      if (sections.has(section)) return;

      sections.add(section);
      section.style.setProperty('--michele-entry-delay', `${(index % 4) * 70}ms`);
      observer.observe(section);
    });
  };

  body.classList.add('michele-entry-ready');
  observeSections();

  new MutationObserver(observeSections).observe(body, { childList: true, subtree: true });
  reducedMotion.addEventListener('change', (event) => {
    if (event.matches) window.location.reload();
  });
})();
